import React, { memo, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';
// Import UI Components
import { BusyLoader } from '@geneui/components';
// Import Components
import GeneralInfo from 'components/BonusModal/GeneralInfo';
import BonusCalculationLogic from './BonusCalculationLogic';
// Import Services
import { TemplateHttpService } from 'services/http';
// Import Hooks
import { useRequest } from 'hooks';
// Import Constants
import { BonusTriggerType, l } from 'constants/common';
// Import Context
import { useVersionHistoryContext } from 'components/VersionHistory';

const CampaignBonusInfoModalBody = ({ campaignBonus, bonusInfo, isLoading }) => {
    const { t } = useTranslation();
    const { doGetRequest } = useRequest();

    const [internalMessageTitle, setInternalMessageTitle] = useState(null);

    const { pointInTime } = useVersionHistoryContext();

    const { getTemplateRequest } = useMemo(
        () => ({
            getTemplateRequest: TemplateHttpService.getTemplate(),
        }),
        [],
    );

    const isBonusTriggerTypeManual = campaignBonus?.TriggerType === BonusTriggerType.Manual;

    const init = () => {
        if (!isNil(campaignBonus?.InternalTemplateId)) {
            doGetRequest(getTemplateRequest.request, {
                queryString: { templateId: campaignBonus.InternalTemplateId, pointInTime },
                successCallback: (data) => {
                    setInternalMessageTitle(data?.Name);
                },
            });
        }
    };

    const cleanUp = () => {
        return () => {
            getTemplateRequest.cancel('CampaignBonusInfoModalBody:getTemplateRequest');
        };
    };

    useEffect(init, []);
    useEffect(cleanUp, []);

    return (
        <BusyLoader isBusy={isLoading} type="spinner" spinnerSize="medium">
            <div className="crm-scrollable-container">
                <GeneralInfo
                    id={bonusInfo?.Id}
                    title={bonusInfo?.Name}
                    description={bonusInfo?.Description}
                    type={bonusInfo?.Type}
                    startDate={bonusInfo?.StartDate}
                    endDate={bonusInfo?.EndDate}
                    state={bonusInfo?.State}
                    walletType={bonusInfo?.BalanceType}
                    internalMessageTitle={internalMessageTitle}
                />
                <div className="segment-modal-head">
                    {isBonusTriggerTypeManual && (
                        <div className="title-wrapper">
                            <p className="title-wrapper-text">{t(l.BonusCalculationLogic)}</p>
                            <span className="title-wrapper-line" />
                        </div>
                    )}
                    <BonusCalculationLogic campaignBonus={campaignBonus} bonusInfo={bonusInfo} isLoading={isLoading} />
                </div>
            </div>
        </BusyLoader>
    );
};

CampaignBonusInfoModalBody.propTypes = {
    campaignBonus: PropTypes.object,
    bonusInfo: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
};

export default memo(CampaignBonusInfoModalBody);
